var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFilterIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0V1.66667H14.1667L10 7.91667V15H5V7.91667L0.833333 1.66667H0V0H15ZM2.83642 1.66667L6.66667 7.412V13.3333H8.33333V7.412L12.1636 1.66667H2.83642Z",
    fill: "#1B1F1E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilterIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/FilterIcon.ba623829.svg";
export { ForwardRef as ReactComponent };